import { z } from "zod";

/**
 * Zod schema mirroring `TaskMetadataBase` from `@arti/domain-types`.
 *
 * Every task type's metadata extends this base shape. The `flow.kind`
 * field is the versioned task type discriminator.
 */
export const taskMetadataBaseSchema = z.object({
  flow: z.object({ kind: z.string().min(1) }).passthrough(),
  source_control_provider_id: z.string().min(1).nullable(),
  source_control_repository_allowlist: z.array(z.string()),
  ticket_id: z.string().min(1).nullable(),
});
